import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserData } from 'API';
import { SearchTypeEnum } from 'Enum/SearchTypeEnum';

export interface ImposterState {
  imposterId: string;
  imposterType: SearchTypeEnum;
  isAdmin: boolean;
  authenticatedUser: Partial<UserData>;
  fakeUser: Partial<UserData>;
  isReadNotifications: boolean;
  isLawyer: boolean;
  representativeName?: string;
  isLawyerArea: boolean;
}

const initialState: ImposterState = {
  imposterId: '',
  imposterType: SearchTypeEnum.ID,
  isAdmin: false,
  authenticatedUser: {},
  fakeUser: {},
  isReadNotifications: true,
  isLawyer: false,
  isLawyerArea: sessionStorage.getItem('isLawyerArea') === 'true',
};

export const imposterSlice = createSlice({
  name: 'imposter',
  initialState,
  reducers: {
    setFakeUser: (
      state: ImposterState,
      action: PayloadAction<Partial<UserData>>,
    ) => {
      state.fakeUser = action.payload;
    },
    setUser: (
      state: ImposterState,
      action: PayloadAction<Partial<UserData>>,
    ) => {
      state.authenticatedUser = action.payload;
    },
    setImposterId: (state: ImposterState, action: PayloadAction<string>) => {
      state.imposterId = action.payload;
    },
    setImposterType: (
      state: ImposterState,
      action: PayloadAction<SearchTypeEnum>,
    ) => {
      state.imposterType = action.payload;
    },
    setIsAdmin: (state: ImposterState, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload;
    },
    setIsReadNotifications: (
      state: ImposterState,
      action: PayloadAction<boolean>,
    ) => {
      state.isReadNotifications = action.payload;
    },
    setIsLawyer: (state: ImposterState, action: PayloadAction<boolean>) => {
      state.isLawyer = action.payload;
    },
    setRepresentativeName: (
      state: ImposterState,
      action: PayloadAction<string>,
    ) => {
      state.representativeName = action.payload;
    },
    setIsLawyerArea: (state, action: PayloadAction<boolean>) => {
      state.isLawyerArea = action.payload;
    },
  },
});

export const {
  setImposterId,
  setImposterType,
  setIsAdmin,
  setFakeUser,
  setUser,
  setIsReadNotifications,
  setIsLawyer,
  setRepresentativeName,
  setIsLawyerArea,
} = imposterSlice.actions;

export default imposterSlice.reducer;
